import UsuarioFab from './UsuarioFab';

export default UsuarioFab;
